export default "__VITE_ASSET__f703e116__"